<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Política de Privacidade';
</script>

<PageHeader title={titlePage}></PageHeader>
<div class="container clearfix text-justify">

	<span class="float-sm-left mr-20" style="width: 535px; text-align: center; padding-bottom: 20px;">
		<div>
			​<picture class="image-gallery float-sm-left mr-20 pb-10" style="display: flex;">
				<img class="img-fluid" src="/assets/images/privacidade.jpg" alt="Jovem satisfeita utilizando laptop">
			</picture>
		</div>            
	</span>	

	<p>
		Todas as suas informações pessoais recolhidas, serão usadas para o ajudar a tornar a sua visita no nosso site o mais produtiva e agradável possível.
	</p>
	<p>
		A garantia da confidencialidade dos dados pessoais dos utilizadores do nosso site é importante para a Imobiliária Callegaro.
	</p>
	<p>
		Todas as informações pessoais relativas a membros, assinantes, clientes ou visitantes que usem o site da Imobiliária Callegaro serão tratadas em concordância com a Lei da Proteção de Dados Pessoais de 26 de outubro de 1998 (Lei n.º 67/98).
	</p>
	<p>
		A informação pessoal recolhida pode incluir o seu nome, e-mail, número de telefone e/ou telemóvel, morada, data de nascimento e/ou outros.
	</p>
	<p>
		O uso do site da Imobiliária Callegaro pressupõe a aceitação deste Acordo de privacidade. A equipe da Imobiliária Callegaro reserva-se ao direito de alterar este acordo sem aviso prévio. Deste modo, recomendamos que consulte a nossa política de privacidade com regularidade de forma a estar sempre atualizado.
	</p>

	<br />
	<h2 class="title color-primary mb-20">
		LIGAÇÕES A SITES DE TERCEIROS
	</h2>
	<p>
		A Imobiliária Callegaro possui ligações para outros sites, os quais, a nosso ver, podem conter informações / ferramentas úteis para os nossos visitantes. A nossa política de privacidade não é aplicada a sites de terceiros, pelo que, caso visite outro site a partir do nosso deverá ler a politica de privacidade do mesmo.
	</p>
	<p>
		Não nos responsabilizamos pela política de privacidade ou conteúdo presente nesses mesmos sites.
	</p>

	<br />

</div>
